export const PROGRESS_CSS = `
  [data-string-progress-summary] {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 2px 6px 6px;
  }

  [data-string-progress-control] {
    display: grid;
    gap: 8px;
  }

  [data-string-progress-slider] {
    width: 100%;
    margin: 0;
    appearance: none;
    -webkit-appearance: none;
    background: transparent;
    cursor: pointer;
  }

  [data-string-progress-slider]:focus-visible {
    outline: none;
  }

  [data-string-progress-slider]::-webkit-slider-runnable-track {
    height: 20px;
    border-radius: 8px;
    background:
      linear-gradient(
        90deg,
        #ffba95 0%,
        #ffba95 var(--string-progress-slider-fill, 0%),
        rgba(17, 17, 17, 0.08) var(--string-progress-slider-fill, 0%),
        rgba(17, 17, 17, 0.08) 100%
      );
  }

  [data-string-progress-slider]::-moz-range-track {
    height: 8px;
    border-radius: 999px;
    background: rgba(17, 17, 17, 0.08);
  }

  [data-string-progress-slider]::-moz-range-progress {
    height: 8px;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--string-dev-accent) 0%, #ff8b4d 100%);
  }

  [data-string-progress-slider]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 8px;
    background: var(--string-dev-accent);
  }

  [data-string-progress-slider]::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border: 2px solid #fff;
    border-radius: 999px;
    background: var(--string-dev-accent);
    box-shadow: 0 2px 8px rgba(17, 17, 17, 0.16);
  }

  [data-string-progress-slider]:focus-visible::-webkit-slider-thumb {
    box-shadow: 0 0 0 3px rgba(17, 17, 17, 0.12), 0 2px 8px rgba(17, 17, 17, 0.16);
  }

  [data-string-progress-slider]:focus-visible::-moz-range-thumb {
    box-shadow: 0 0 0 3px rgba(17, 17, 17, 0.12), 0 2px 8px rgba(17, 17, 17, 0.16);
  }

  [data-string-progress-meta] {
    display: grid;
    gap: 2px;
  }

  [data-string-progress-row] {
    display: grid;
    grid-template-columns: 50% minmax(0, 1fr);
    align-items: baseline;
    font-size: 10px;
    font-weight: 500;
    background-color: #F1F1F1;
    
    border-radius: 8px;
  }

  [data-string-progress-label] {
  padding: 8px;
  border-right: 1px solid rgba(17, 17, 17, 0.08);
  }

  [data-string-progress-value] {
    min-width: 0;
    color: var(--string-dev-panel-text);
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px;
  }
`;
